import { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import api from '../api';
import { toast } from 'react-toastify';
import { Helmet } from "react-helmet";

const ContactUs = (settings) => {
    const [metaData, setMetaData] = useState({});
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        email: "",
        phone: "",
        message: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const updatedFormData = { ...formData };

            console.log("Form Data to Submit:", updatedFormData);

            const response = await api.post("/contact/save", updatedFormData);

            const { result, message } = response.data;

            if (result) {
                toast.success(message);
                setFormData({
                    name: "",
                    surname: "",
                    email: "",
                    phone: "",
                    message: ""
                }); // Clear form after success
            } else {
                toast.error(message || "An error occurred");
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (settings.setting && settings.setting.length > 0) {
            const meta = {};
            settings.setting.forEach((setting) => {
                if (setting.type === "facebook_link") {
                    meta.facebook_link = setting.value;
                }
                if (setting.type === "twitter_link") {
                    meta.twitter_link = setting.value;
                }
                if (setting.type === "instagram_link") {
                    meta.instagram_link = setting.value;
                }
                if (setting.type === "linkedin_link") {
                    meta.linkedin_link = setting.value;
                }
                if (setting.type === "contact_email") {
                    meta.contact_email = setting.value;
                }
                if (setting.type === "contact_phone") {
                    meta.contact_phone = setting.value;
                }
                if (setting.type === "contact_address") {
                    meta.contact_address = setting.value;
                }
            });
            setMetaData(meta);
        }
    }, [settings]);
    return (
        <>

            <Helmet>
                <title>Contact Us | Get in Touch with ELLY DECOR</title>
                <meta name="title" content="Contact Us | Get in Touch with ELLY DECOR" />
                <meta name="description" content="Reach out to ELLY DECOR for inquiries or support. Contact us through our phone, email, or contact form for assistance with furniture and home decor products." />
            </Helmet>

            <section className="contact-page-title" style={{ backgroundImage: `url('/images/contact-us.png')` }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className=" responsive-main-heading p-5">GET IN TOUCH WITH US</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="contact-us py-0 py-lg-5">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-6 mb-0 mb-lg-4 mb-lg-0">
                            <h4 className="heading mb-3 text-center text-lg-start">Where to Find Us</h4>
                            <div className="map-container mb-4">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.473258197073!2d77.47926199999999!3d28.4351468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cc1a4f2c1208b%3A0x31ccdab75de49592!2sELLY%20DECOR%20%7C%20Wall%20Studio%20%26%20Soft%20Furnishing%20Store!5e0!3m2!1sen!2sin!4v1756885806281!5m2!1sen!2sin"
                                    width="100%"
                                    height="300"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Elly Decor Location"
                                ></iframe>
                            </div>

                            <h5 className="mb-2 text-center borderBottm">Contact Detail</h5>
                            <div className='row mt-3 mt-lg-0'>
                                <div className="col-6 mb-4 mb-lg-0">
                                    <p className="mb-1">Shop 2,3, CLR Complex<br />Sector 149, Noida<br />Uttar Pradesh - 201310</p>
                                    <div className="d-flex gap-3 mt-3">
                                        <p>Social Links :</p>
                                        {metaData.twitter_link && (
                                            <a href={metaData.twitter_link}><i className="fab fa-twitter"></i></a>
                                        )}
                                        {metaData.instagram_link && (
                                            <a href={metaData.instagram_link}><i className="fab fa-instagram"></i></a>
                                        )}
                                        {metaData.facebook_link && (
                                            <a href={metaData.facebook_link}><i className="fab fa-facebook"></i></a>
                                        )}
                                        {metaData.linkedin_link && (
                                            <a href={metaData.linkedin_link}><i className="fab fa-linkedin-in"></i></a>
                                        )}
                                    </div>
                                </div>

                                <div className="col-6 mb-4 mb-lg-0">
                                    <p className="mb-1">
                                        <a href="tel:+919821495696"><i className="fa-solid fa-phone"></i> +91 98214 95696</a><br />
                                        <a href="tel:+919313007340"><i className="fa-solid fa-phone"></i> +91 93130 07340</a>
                                    </p>
                                    <p className="mb-1">
                                        <a href="mailto:info@ellydecor.in"><i className="fa-solid fa-envelope"></i> info@ellydecor.in</a><br />
                                        <a href="mailto:ellydecor.in@gmail.com"><i className="fa-solid fa-envelope"></i> ellydecor.in@gmail.com</a>
                                    </p>
                                    
                                </div>

                            </div>




                            {/* Social icons */}

                        </div>

                        {/* Right Column: Contact Form */}
                        <div className="col-lg-6">
                            <h4 className="heading mb-3">Leave a Message</h4>
                            <form className="form" onSubmit={handleSubmit} method="post">
                                <div className="row">
                                    <div className="col-sm-6 mb-3">
                                        <input name="name" className="form-control" type="text" value={formData.name} onChange={handleChange} placeholder="First name *" />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <input name="surname" className="form-control" type="text" value={formData.surname} onChange={handleChange} placeholder="Last name" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mb-3">
                                        <input name="email" className="form-control" type="email" value={formData.email} onChange={handleChange} placeholder="Email *" />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <input name="phone" className="form-control" type="text" value={formData.phone} onChange={handleChange} placeholder="Phone" />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <input name="subject" className="form-control" type="text" placeholder="Subject" />
                                </div>
                                <div className="mb-3">
                                    <textarea name="message" className="form-control" rows="5" value={formData.message} onChange={handleChange} placeholder="Your message"></textarea>
                                </div>
                                <div className="text-center text-lg-end mb-4">
                                    <button type="submit" className="heroLink" data-loading-text="Please wait..."><span className="btn-title">Send message</span></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>



        </>
    );
};

export default ContactUs;
